import styled from "styled-components";

const Header2 = styled.h1`
  font-size: 1.5rem;
`;

export default Header2;
